import React, { useState, useEffect } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from 'reactstrap';
import './PictureSlider.scss';

const PictureSlider = (props) => {
  const { items } = props;

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    clearInterval(timerId);
    const newTimerId = setInterval(() => {
      next();
    }, items[activeIndex]?.interval || 6000);
    setTimerId(newTimerId);

    return () => clearInterval(newTimerId);
  }, [activeIndex]);

  const slides = items?.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.image}
      >
        <a href={item.landing_url || undefined}>
          <img src={item.image} alt={item.image_alt_text} />
          <CarouselCaption
            captionHeader={item.headline}
            captionText={
              <>
                {item.sub_headline_1}
                {item.sub_headline_2 && (
                  <>
                    <br />
                    {item.sub_headline_2}
                  </>
                )}
              </>
            }
          />
        </a>
      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      className="pictureSlider"
      interval={false}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  );
};

export default PictureSlider;
